import { render, staticRenderFns } from "./CdkNewsItemDetailText.vue?vue&type=template&id=3646c596&"
import script from "./CdkNewsItemDetailText.vue?vue&type=script&lang=ts&"
export * from "./CdkNewsItemDetailText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports